<app-hero
	[title]="'hero.profile' | translate"
	imageDesktop="assets/hero/user-profile-hero-3840x400.jpg"
	imageMobile="assets/hero/user-profile-hero-768x180.jpg"
/>
<div class="profile-page mt-4">
	<button
		class="btn-back d-md-none"
		(click)="goBackToMenu()"
		type="button"
	>
		<span class="arrow">‹</span>
		<span class="text">{{ "report.button.back" | translate }}</span>
	</button>

	@if (showRightPanel) {
		<div class="mobile-section-title d-md-none">
			@switch (activeSection) {
				@case ("personal") {
					{{ "userProfile.userData" | translate }}
				}
				@case ("dealer") {
					{{ "user.companyData" | translate }}
				}
				@case ("payment") {
					{{ "userProfile.onlinePayment" | translate }}
				}
				@case ("consents") {
					{{ "user.consents" | translate }}
				}
				@case ("searches") {
					{{ "auction.search.savedSearches" | translate }}
				}
			}
		</div>
	}

	<!-- LEFT PANEL -->
	<div
		class="profile-panel left"
		[class.hidden]="showRightPanel"
	>
		<ul class="profile-menu">
			<li
				[class.active]="activeSection === 'personal'"
				(click)="setSection('personal')"
			>
				{{ "userProfile.userData" | translate }}
			</li>
			<li
				[class.active]="activeSection === 'dealer'"
				(click)="setSection('dealer')"
			>
				{{ "user.companyData" | translate }}
			</li>

			@if (user.idMarket === "IT") {
				<li
					[class.active]="activeSection === 'payment'"
					(click)="setSection('payment')"
				>
					{{ "userProfile.onlinePayment" | translate }}
				</li>
			}

			<li
				[class.active]="activeSection === 'consents'"
				(click)="setSection('consents')"
			>
				{{ "user.consents" | translate }}
			</li>
			<li
				[class.active]="activeSection === 'searches'"
				(click)="setSection('searches')"
			>
				{{ "auction.search.savedSearches" | translate }}
			</li>
		</ul>
	</div>

	<!-- RIGHT PANEL -->
	<div
		class="profile-panel right"
		[class.hidden]="!(showRightPanel && user)"
	>
		@switch (activeSection) {
			@case ("personal") {
				<div class="profile-card">
					<div class="info-grid">
						<div class="info-item">
							<label>{{ "userProfile.firstName" | translate }}</label>
							<span>{{ user.name }}</span>
						</div>

						<div class="info-item">
							<label>{{ "userProfile.lastName" | translate }}</label>
							<span>{{ user.surname }}</span>
						</div>

						<div class="info-item">
							<label>{{ "userProfile.birthDate" | translate }}</label>
							<span>{{ user.birthDate | date: "dd/MM/yyyy" }}</span>
						</div>
						@if (user.idMarket === "IT") {
							<div class="info-item">
								<label>{{ "userProfile.fiscalCode" | translate }}</label>
								<span>{{ user.fiscalCode }}</span>
							</div>
						}
						<div class="info-item">
							<label>{{ "userProfile.email" | translate }}</label>
							<span>{{ user.email }}</span>
							<!-- <input type="text" formControlName="email">-->
						</div>

						<!-- <div class="info-item">
							<label>{{ "userProfile.language" | translate }}</label>
							<select formControlName="preferredLanguage">
								@for (opt of languages; track opt) {
									<option [value]="opt">{{ opt }}</option>
								}
							</select>
						</div> -->
					</div>
				</div>
			}
			@case ("dealer") {
				<div class="profile-card">
					<div class="info-grid">
						@if (dealer) {
							<div class="info-item">
								<label>{{ "userProfile.businessName" | translate }}</label>
								<span>{{ dealer.businessName }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.address" | translate }}</label>
								<span>{{ dealer.address }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.city" | translate }}</label>
								<span>{{ dealer.city }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.postalCode" | translate }}</label>
								<span>{{ dealer.postalCode }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.country" | translate }}</label>
								<span>{{ dealer.country }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.referenceSurname" | translate }}</label>
								<span>{{ dealer.referenceSurname }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.vatCode" | translate }}</label>
								<span>{{ dealer.vatCode }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.email" | translate }}</label>
								<span>{{ dealer.email }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.telephone" | translate }}</label>
								<span>{{ dealer.mobile }}</span>
							</div>
						}
					</div>
				</div>
			}
			@case ("payment") {
				<div class="profile-card">
					<form [formGroup]="dealerForm">
						<div class="info-item">
							<label for="templateName">{{ "userProfile.iban" | translate }}*</label>
						</div>
						<div class="mb-4">
							<mat-form-field
								appearance="fill"
								class="w-100"
							>
								<input
									matInput
									id="templateName"
									type="text"
									name="iban"
									formControlName="iban"
									maxlength="35"
									required
								/>
							</mat-form-field>
						</div>
						<div
							class="info-item"
							style="border-top: 1px solid #e0e2e6"
						>
							<span style="margin: 1rem 0">
								{{ "userProfile.onlinePaymentDisclaimer" | translate }}
							</span>
						</div>
						<div class="col-sm-12">
							<input
								type="checkbox"
								formControlName="flgOnlinePayment"
							/>
							<span style="margin-left: 8px">{{ "userProfile.acceptOnlinePayment" | translate }}</span>
						</div>
						<div class="col-sm-12 text-center">
							<span>
								<a
									(click)="onIban()"
									[class.disabled]="dealerForm.invalid"
									class="btn btn-blue btn-ico btn-ico-save-before text-uppercase"
								>
									{{ "userProfile.save" | translate }}
								</a>
							</span>
						</div>
					</form>
				</div>
			}
			@case ("consents") {
				<div
					class="profile-card"
					[formGroup]="userForm"
				>
					<div class="consent-row">
						<input
							type="checkbox"
							formControlName="consent1"
							id="consent1"
						/>
						<div class="info-item">
							<label>{{ "consenso-1.p1" | translate }}</label>
							<span>{{ "consenso-1.p2" | translate }}</span>
						</div>
					</div>

					@if (!["DE", "AT"].includes(user.idMarket)) {
						<div class="consent-row">
							<input
								type="checkbox"
								formControlName="consent2"
								id="consent2"
							/>
							<div class="info-item">
								<label>{{ "consenso-2.p1" | translate }}</label>
								<span>{{ "consenso-2.p2" | translate }}</span>
							</div>
						</div>
					}

					<div class="consent-row">
						<input
							type="checkbox"
							formControlName="consent3"
							id="consent3"
						/>
						<div class="info-item">
							<label>{{ "consenso-3.p1" | translate }}</label>
							<span>{{ "consenso-3.p2" | translate }}</span>
						</div>
					</div>

					<div class="text-center mt-4">
						<a
							(click)="onEdit()"
							[class.disabled]="userForm.invalid"
							class="btn btn-blue btn-ico btn-ico-save-before text-uppercase"
						>
							{{ "userProfile.edit" | translate }}
						</a>
					</div>
				</div>
			}
			@case ("searches") {
				<div class="profile-card py-0 px-4">
					@if (savedSearches.length) {
						@for (search of savedSearches; track search.id) {
							<article class="row g-0 search-container rounded-3 p-3 my-4">
								<div class="col-12 col-lg-6 order-0">
									<strong>{{ "auction.search.savedOn" | translate }} {{ search.dateModify | date: "dd/MM/yyyy" }}</strong>
								</div>
								<div class="col-12 col-lg-6 text-center text-lg-end order-3 order-lg-1">
									<button
										class="btn btn-transparent btn-ico btn-ico-trash-before text-uppercase"
										(click)="deleteSearch(search.id!)"
									>
										{{ "auction.search.deleteSearch" | translate }}
									</button>
								</div>
								<dl class="col-12 col-lg d-flex flex-wrap gap-2 pb-0 order-2 order-lg-2 text-uppercase pt-3">
									@if (search.brand) {
										<div
											class="btn btn-outline text-truncate bg-lightgray text-xs cursor-pointer"
											title="{{ 'auction.details.brand' | translate }}: {{ search.brand }}"
										>
											<dt class="d-inline">
												{{ "auction.details.brand" | translate }}
											</dt>
											:
											<dd class="mb-0 d-inline">{{ search.brand }}</dd>
										</div>
									}
									@if (search.model) {
										<div
											class="btn btn-outline text-truncate bg-lightgray text-xs cursor-pointer"
											title="{{ 'auction.details.model' | translate }}: {{ search.model }}"
										>
											<dt class="d-inline">
												{{ "auction.details.model" | translate }}
											</dt>
											:
											<dd class="mb-0 d-inline">{{ search.model }}</dd>
										</div>
									}
									<div
										class="btn btn-outline text-truncate bg-lightgray text-xs cursor-pointer"
										title="{{ 'auction.details.licensePlate' | translate }}: {{ search.kmFrom }} - {{ search.kmTo }}"
									>
										<dt class="d-inline">
											{{ (user.idMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}
										</dt>
										:
										<dd class="mb-0 d-inline">{{ search.kmFrom }} - {{ search.kmTo }}</dd>
									</div>
									<div
										class="btn btn-outline text-truncate bg-lightgray text-xs"
										title="{{ 'auction.details.frame' | translate }}: {{ search.registrationYearFrom }} - {{ search.registrationYearTo }}"
									>
										<dt class="d-inline">
											{{ "auction.details.year" | translate }}
										</dt>
										:
										<dd class="mb-0 d-inline">{{ search.registrationYearFrom }} - {{ search.registrationYearTo }}</dd>
									</div>
								</dl>
								<div class="col-12 col-lg-auto pt-2 pt-lg-3 order-1 order-lg-3 text-center text-lg-end align-self-lg-start">
									<label
										for="getNotifications{{ search.id }}"
										class="me-2"
									>
										{{ "auction.search.getDailyUpdates" | translate }}
									</label>
									<input
										type="checkbox"
										class="onofftoggle"
										id="getNotifications{{ search.id }}"
										[checked]="search.flgNotification"
										(change)="toggleSearchNotification(search.id!, (search.flgNotification = $event.target.checked))"
									/>
									<label for="getNotifications{{ search.id }}"></label>
								</div>
							</article>
						}
					} @else {
						<div class="p-5 text-center">
							<div
								class="p-3 d-inline-block"
								[style.backgroundImage]="'url(./assets/icons/lens.svg)'"
							>
								<div class="p-1"></div>
							</div>
							<h4 class="text-xl">{{ "auction.search.noSavedSearchesTitle" | translate }}</h4>
							<h5 class="text-lg">{{ "auction.search.noSavedSearchesSubtitle" | translate }}</h5>
						</div>
					}
				</div>
			}
		}
	</div>
</div>